import { debounce, isElement, forEach } from 'lodash';

const moduleName = 'menu-toggle',
    selectors = {
        main: `.js-${moduleName}`,
        container: `.js-${moduleName}__container`,
        menu: `.js-${moduleName}__menu`
    };

export class MenuToggle {

    constructor(el) {
        if (!isElement(el)) {
            return false;
        }

        this.el = el;
        this.containers = document.querySelectorAll(selectors.container);
        this.menus = document.querySelectorAll(selectors.menu);
        this.init();
    }

    _hideMenus(menus) {
        forEach(menus, (menu) => {
            if (menu.classList.contains('is-active')) {
                menu.classList.remove('is-active');
            }
        });
    }

    _showMenus(menus) {
        forEach(menus, (menu) => {
            menu.classList.add('is-active');
        });
    }

    bindEvents() {
        this.el.addEventListener(
            'click',
            debounce(
                () => {

                    forEach(this.containers, (container) => {
                        if (container.classList.contains('is-active')) {
                            this.el.setAttribute('aria-expanded', 'false');
                            container.classList.remove('is-active');
                            this._hideMenus(this.menus);
                        } else {
                            container.classList.add('is-active');
                            this.el.setAttribute('aria-expanded', 'true');
                            this._showMenus(this.menus);
                        }
                    });
                }
                , 200, { 'leading': false, 'trailing': true }
            )
        );
    }

    init() {
        this.bindEvents();
    }
}

function initMenu(elements = document.querySelectorAll(selectors.main)) {
    forEach(elements, menuElement => {
        new MenuToggle(menuElement);
    });
}

initMenu();